import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm4.768 7.231c-.31-.308-.81-.308-1.12 0l-4.886 4.865-2.41-2.4c-.31-.308-.81-.308-1.12 0-.31.308-.31.807 0 1.115l2.97 2.958c.31.308.811.308 1.12 0l5.446-5.423c.31-.308.31-.807 0-1.115z"
      transform="translate(2 2)"
      fill={fill}
    />
  </g>
);

export default Icon;
